import { Component, Inject } from '@angular/core';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { DocumentLabelDescriptions } from 'src/app/shared/constants-and-enums/document-labels';

@Component({
    standalone: false,
    selector: 'app-label-selection-dialog',
    templateUrl: './label-selection-dialog.component.html',
    styleUrls: ['./label-selection-dialog.component.scss']
})
export class LabelSelectionDialogComponent {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.MEDIUM,
        showToggleFullScreenButton: false
    };

    selectedLabels: string[] = [];

    constructor(
        public dialogRef: MatDialogRef<LabelSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string[]
    ) {}

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onSaveClick(): void {
        this.dialogRef.close(this.selectedLabels);
    }

    updateSelectedLabels(change: any) {
        const checked = change.target.checked;
        const value = change.target.value;

        if (checked === true) {
            this.selectedLabels.push(value);
        } else {
            this.selectedLabels = this.selectedLabels.filter((r) => r !== value);
        }
    }

    getLabelDescription(label: string): string {
        return DocumentLabelDescriptions.get(label);
    }
}
